import NotFound from "./Components/NotFound";
import HomePageadmin from "./Pages/Admin/HomePage";
import { CategoryTable } from "./Pages/Admin/Category";
import ProductsPage from "./Pages/ProductsPage";
import AddCategory from "./Pages/Admin/AddCategory";
import BusinessListPage from "./Pages/Admin/Business";
import AddBusiness from "./Pages/Admin/BusinessAdd";
import UpdateBusiness from "./Pages/Admin/UpdateBusiness";
import UserList from "./Pages/Admin/Userlist";
import Banner from "./Pages/Admin/Banner";
import SubCategoryList from "./Pages/Admin/SubCategory/SubCategoryList";
import AddSubCategory from "./Pages/Admin/SubCategory/AddSubCategory";
import VideoModule from "./Pages/Admin/VideoModule";
import EventBanner from "./Pages/Admin/EventBanner";
import ExcelUpload from "./Pages/Admin/ExcelUpload";

import AdminProfile from "./Pages/Admin/AdminProfile";

import Settings from "./Pages/Admin/Settings";

const AdminRoutes = [
  {
    path: "/admin/home",
    name: "Home",
    component: HomePageadmin,
  },
  {
    path: "/admin/profile",
    name: "Admin Profile",
    component: AdminProfile,
  },
  {
    path: "/products",
    name: "Products",
    component: ProductsPage,
  },
  {
    path: "/admin/category-list",
    name: "Category",
    component: CategoryTable,
  },
  {
    path: "/admin/categorys/add",
    name: "Add Category",
    component: AddCategory
  },
  {
    path: "/admin/subcategory-list",
    name: "Sub Category",
    component: SubCategoryList,
  },
  {
    path: "/admin/subcategory-add",
    name: "Add Sub Category",
    component: AddSubCategory
  },
  {
    path: "/admin/business-list",
    name: "Business List",
    component: BusinessListPage
  },
  {
    path: "/admin/business-list/add",
    name: "Add Business",
    component: AddBusiness
  },
  {
    path: "/admin/business-list/update/:id",
    name: "Update Business",
    component: UpdateBusiness
  },

  {
    path: "/admin/user-list",
    name: "User List",
    component: UserList,
  },

  {
    path: "/admin/banner",
    name: "Banner List",
    component: Banner,
  },
  {
    path: "/admin/video",
    name: "Learn Islamic Method of Business",
    component: VideoModule,
  },
  {
    path: "/admin/event-banner",
    name: "Event Banner List",
    component: EventBanner,
  },
  {
    path: "/admin/excel-upload",
    name: "Excel Upload",
    component: ExcelUpload,
  },
  {
    path: "/admin/settings",
    name: "Settings",
    component: Settings,
  },

];

export { AdminRoutes };
